import { NewsFormActionsEnum } from '../enums/NewsFormActionsEnum';
import { INewsFormState } from '../interfaces/INewsFormState';
import { NewsFormAction } from '../types/NewsFormAction';

const initial: INewsFormState = {};

export function newsFormReducer(state = initial, action: NewsFormAction) {
  switch (action.type) {
    case NewsFormActionsEnum.NEWS_FORM_SET_SINGLE_NEWS: {
      const newState: INewsFormState = {
        ...state,
        singleNews: action.payload.singleNews,
      };

      return newState;
    }
    case NewsFormActionsEnum.NEWS_FORM_SET_NEWS_ID: {
      const newState: INewsFormState = {
        ...state,
        newsId: action.payload.newsId,
      };

      return newState;
    }
    default:
      return state;
  }
}
